import { FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';

import Button from './Button';

type PropTypes = {
	connected: boolean;
};
export default function Action({ connected }: PropTypes) {
	return connected ? (
		<Button
			data-test="sign-out"
			to="/auth/sign-out"
			innerText="Sign Out"
			Icon={FaSignOutAlt}
		/>
	) : (
		<Button
			data-test="sign-in"
			to="/auth/sign-in"
			innerText="Sign In"
			Icon={FaSignInAlt}
		/>
	);
}
